export const MAX_ISINS_FOR_SINGLE_ISIN_REPORT = 10;
export const ISIN_REGEX = /^[A-Z]{2}[0-9A-Z]{9}[0-9]{1}$/;
export const COMMON_CODE_REGEX = /^\d{1,9}$/;
export const SINGLE_ISIN_PRODUCT_ID = "CS_GHR_SI";
export const COMMON_CODE_LENGTH = 9;
export const COMMON_CODE_PADDING_CHAR = "0";
export const ISIN_SEPARATOR = /[\n,]/; // endline or ,
export const LAST_COMMA_REGEX = /,$/;
